import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api/' : '/api/',
  // timeout: 10000,
  headers: {
    // Authorization: localStorage.getItem('token'),
  },
});

instance.interceptors.request.use((config) => {
  // Do something before request is sent
  return config;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

instance.interceptors.response.use((response) => {
  // Do something with response data
  return response;
}, (error) => {
  if (error.response.status === 401) {
    location.href = error.response.data.attributes.authorizeUrl;
  }
  return Promise.reject(error);
});

export default instance;
